// extracted by mini-css-extract-plugin
export var fullWidthButton = "_cw-0";